import { render, staticRenderFns } from "./NewSubscription.vue?vue&type=template&id=56d037ad&scoped=true&"
import script from "./NewSubscription.vue?vue&type=script&lang=js&"
export * from "./NewSubscription.vue?vue&type=script&lang=js&"
import style0 from "./NewSubscription.vue?vue&type=style&index=0&id=56d037ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d037ad",
  null
  
)

export default component.exports